/* eslint no-undef: 'off' */
import $ from "jquery";
import api from "./data/ajax";

const removeCoupoun = () => {
  const el = {
    trigger: "a.woocommerce-remove-coupon[data-coupon]",
  };

  $(document).on("click", el.trigger, (e) => {
    e.preventDefault();
    const coupon_code = $(e.target).data("coupon");
    const type_tax = $(
      "#myparcel-delivery-options__deliveryMoment--evening"
    ).is(":checked")
      ? "evening"
      : "standard";

    api
      .apply_coupon(coupon_code, {
        is_remove: "1",
        type_tax,
      })
      .done((res) => {
        const fragments = res.fragments;
        // const old_fragments = JSON.parse(sessionStorage.getItem(wc_cart_fragments_params.fragment_name))
        // eslint-disable-next-line no-console
        // console.log(fragments);
        $.each(fragments, (key, value) => {
          $(key).html(value);
        });
      })
      .catch((xhr) => {
        // eslint-disable-next-line no-console
        console.log("Error:", xhr.responseJSON);
      });
  });
};

try {
  removeCoupoun();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log("Error:", error);
}
